import { EVerticalNames } from '@constants';
import { IUserInfo } from '@sdk/contracts';
import { Form, FormInstance, Radio } from 'antd';
import { useTranslation } from 'react-i18next';

import { AutonomousCommunitySelector } from '../Form';
import { ExamGroupSelector } from '../Form/ExamGroupSelector';
import {
  UserInfoBranchSelector,
  UserInfoDegreeSelector,
  UserInfoUniversitySelector
} from '../Form/UserInfo';

import { Wrapper, TitleWrapper } from './PceFormContent.styles';

type PceFormContentProps = {
  form: FormInstance<IUserInfo>;
  isManager: boolean;
};

export const PceFormContent: React.FC<PceFormContentProps> = ({ form, isManager }) => {
  const { t } = useTranslation(['DefaultTranslations', 'StudentProfileConfigurationTranslations']);
  const data = Form.useWatch([], form) as IUserInfo | undefined;

  return (
    <Wrapper>
      {isManager && <TitleWrapper>{t(EVerticalNames.UNI)} | PCE</TitleWrapper>}
      <Form.Item
        name={['studyBranch']}
        label={t('StudentProfileConfigurationTranslations:STUDY_BRANCH')}
        initialValue={data?.studyBranch}>
        <UserInfoBranchSelector />
      </Form.Item>
      <Form.Item
        name={['degree']}
        label={t('StudentProfileConfigurationTranslations:DEGREE')}
        initialValue={data?.degree}>
        <UserInfoDegreeSelector />
      </Form.Item>
      <Form.Item
        name={['university']}
        label={t('StudentProfileConfigurationTranslations:UNIVERSITY')}
        initialValue={data?.university}>
        <UserInfoUniversitySelector />
      </Form.Item>
      <Form.Item
        name={['examGroups']}
        label={t('StudentProfileConfigurationTranslations:EXAM_GROUPS')}
        initialValue={data?.examGroups}>
        <ExamGroupSelector
          value={data?.examGroups}
          onChange={(value: string[] | string) =>
            form.setFieldsValue({ examGroups: Array.isArray(value) ? value : [value] })
          }
          mode="multiple"
        />
      </Form.Item>
      <Form.Item
        name={['autonomousCommunity']}
        label={t('AUTONOMOUS_COMMUNITY')}
        rules={[{ required: true, message: t('AUTONOMOUS_COMMUNITY') }]}>
        <AutonomousCommunitySelector
          onChange={value =>
            form.setFieldsValue({
              autonomousCommunity: Array.isArray(value) ? value[0] : value
            })
          }
        />
      </Form.Item>
      <Form.Item
        name={['needVisa']}
        label={t('StudentProfileConfigurationTranslations:DO_YOU_NEED_STUDENT_VISA')}
        initialValue={data?.needVisa}>
        <Radio.Group onChange={e => form.setFieldsValue({ needVisa: e.target.value })}>
          <Radio value={true}>{t('YES')}</Radio>
          <Radio value={false}>{t('NO')}</Radio>
        </Radio.Group>
      </Form.Item>
      <Form.Item
        name={['hasCertificateDegree']}
        label={t('StudentProfileConfigurationTranslations:HAS_CERTIFICATE_DEGREE')}
        initialValue={data?.hasCertificateDegree}>
        <Radio.Group onChange={e => form.setFieldsValue({ hasCertificateDegree: e.target.value })}>
          <Radio value={true}>{t('YES')}</Radio>
          <Radio value={false}>{t('NO')}</Radio>
        </Radio.Group>
      </Form.Item>
      <Form.Item
        name={['hasNotesEquivalence']}
        label={t('StudentProfileConfigurationTranslations:HAS_NOTES_EQUIVALENCE')}
        initialValue={data?.hasNotesEquivalence}>
        <Radio.Group onChange={e => form.setFieldsValue({ hasNotesEquivalence: e.target.value })}>
          <Radio value={true}>{t('YES')}</Radio>
          <Radio value={false}>{t('NO')}</Radio>
        </Radio.Group>
      </Form.Item>
    </Wrapper>
  );
};
